'use client';

import { Breakpoints, useMediaQuery } from '@/app_lib/hooks/useMediaQuery';

interface InlineArticlePianoTemplateProps {
  isDesktopPlacement: boolean;
  isMobilePlacement: boolean;
}

export const InlineArticlePianoTemplate = ({
  isDesktopPlacement,
  isMobilePlacement,
}: InlineArticlePianoTemplateProps) => {
  const isMobile = useMediaQuery(Breakpoints.Mobile);

  const shouldNotRenderMobile = isMobile && !isMobilePlacement;
  const shouldNotRenderDesktop = !(isMobile || isDesktopPlacement);

  if (shouldNotRenderMobile || shouldNotRenderDesktop) {
    return <></>;
  }

  return (
    <div
      className='flex justify-center items-center w-full [&_iframe]:ml-0'
      id='article-piano-template-plea-container'
    />
  );
};
